import React, { useState } from "react";
import { Grid, TextField, Autocomplete, Box, Tooltip, IconButton } from "@mui/material";
import { Search, Refresh } from "@mui/icons-material";
import {
    useMediaQuery,
    useTheme,
} from "@mui/material";
const SearchFilterComponent = ({ sliceResponse, onSearch }) => {
    const [selectedId, setSelectedId] = useState("");
    const [name, setName] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const handleAutocompleteChange = (event, newValue) => {
        setSelectedId(newValue ? newValue._id : "");
    };

    const handleSearch = () => {
        onSearch({ partner_id: selectedId, name, startDate, endDate });
    };

    const handleClear = () => {
        setSelectedId("");
        setName("");
        setStartDate("");
        setEndDate("");
        onSearch({ partner_id: "", name: "", startDate: "", endDate: "" });
    };

    
        const theme = useTheme();
        const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // sm = 600px
    
    return (
        <Grid container spacing={1} alignItems="center">
            <Grid item xs={12} md={4}>
                <Autocomplete
                    size="small"
                    options={sliceResponse || []}
                    getOptionLabel={(option) => `${option.name} (${option.username})`}
                    filterOptions={(options, { inputValue }) =>
                        options.filter(
                            (option) =>
                                option.name.toLowerCase().includes(inputValue.toLowerCase()) ||
                                option.username.toLowerCase().includes(inputValue.toLowerCase())
                        )
                    }
                    onChange={handleAutocompleteChange}
                    value={
                        sliceResponse?.find((option) => option._id === selectedId) || null
                    }
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    renderInput={(params) => (
                        <TextField {...params} label="Search Partner" variant="outlined" />
                    )}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <TextField
                    size="small"
                    label="Name"
                    variant="outlined"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    fullWidth
                />
            </Grid>
            <Grid item xs={5} md={2}>
                <TextField
                    size="small"
                    type="date"
                    label="Start Date"
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    fullWidth
                />
            </Grid>
            <Grid item xs={5} md={2}>
                <TextField
                    size="small"
                    type="date"
                    label="End Date"
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    fullWidth
                />
            </Grid>
            <Grid item xs={2} md={1} container>
                <Grid item>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Tooltip title="Search">
                            <IconButton color="primary" onClick={handleSearch}
                            size={isMobile ? "small" : "medium"}
                                sx={{
                                    p: isMobile ? "0px" : "4px", // ✅ Less padding on mobile
                                }}
                            >
                                <Search />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Reset">
                            <IconButton color="secondary" onClick={handleClear}
                            size={isMobile ? "small" : "medium"}
                                sx={{
                                    p: isMobile ? "0px" : "4px", // ✅ Less padding on mobile
                                }}
                            >
                                <Refresh />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Grid>

            </Grid>
        </Grid>
    );
};

export default SearchFilterComponent;
